$(document).ready(function () {
  if ($("#user_password").length && $("#user_password_confirmation").length) {
    $("#user_password").on('change', validatePassword);
    $("#user_password_confirmation").on('change', validatePassword);
  }
})

function validatePassword(password, confirm_password) {
  var currentLocale = getCurrentLocale();
  var errorMessage = { "fr": "Les mots de passe ne correspondent pas.", "en": "Passwords do not match." };

  var password = $("#user_password");
  var confirm_password = $("#user_password_confirmation");

  if (password.val() != confirm_password.val()) {
    confirm_password.get(0).setCustomValidity(errorMessage[currentLocale]);
  } else {
    confirm_password.get(0).setCustomValidity('');
  }
}
